import { useEffect, useMemo, useState } from 'react';
import { OccupiedArea } from '@perxis-auto/ui-kit/lib';

/**
 * Hack: объект, хранит область занятую элементами управления карты (кнопки зума).
 * Т.к. кнопки зума имеют довольно большие габариты и отступы, пинам на карте остается слишком мало места.
 * Поэтому ширина этой зоны немного уменьшена. При необходимости можно задать подходящие размеры
 * или получать элемент контрола и задавать размеры на основе его реальной разметки.
 *
 * При указанных размерах области, не должно случиться полное перекрытия пина
 * из-за того, что сам пин имеет определенные размеры, он может быть лишь частично перекрыт кнопками.
 */
const rightMapControlsArea = {
  right: 0,
  top: 0,
  width: `48px`,
  height: `100%`,
};

const leftMapControlsArea = {
  left: 0,
  top: 0,
  width: `48px`,
  height: `100%`,
};

/*
 * Хук, возвращающий массив областей, занятых на карте другими элементами.
 * @param containerRef ссылка на элемент объекта располагаемого на карте
 * @param panelPosition расположение панели (слева или справа)
 */

export default function useOccupiedAreas(
  element: HTMLDivElement | null,
  panelPosition: 'left' | 'right' = 'left',
) {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (element) {
      const observer = new ResizeObserver(() => {
        setWidth(element?.offsetWidth);
      });

      observer.observe(element);
      return () => observer.unobserve(element);
    }
  }, [element]);

  const occupiedAreas: Array<OccupiedArea> | undefined = useMemo(() => {
    if (!element) {
      return;
    }
    const mapControlsArea =
      panelPosition === 'left' ? leftMapControlsArea : rightMapControlsArea;

    return [
      mapControlsArea,
      {
        left: 0,
        top: 0,
        width: `${width}`,
        height: `${100}%`,
      },
    ];
  }, [element, panelPosition, width]);

  return occupiedAreas;
}
